module.exports = __webpack_public_path__ + "static/img/2bg_18.bc07acd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_18.png
// module id = 667
// module chunks = 1